import React from 'react';
import BarsContent from "./bars-content.jsx";
import LineContent from "./line-content.jsx";

const GraphicsContent = ({ data }) => {
    return (
        <>
            <BarsContent data={data?.created_by} elementId={'created-by-chart'} title={'Cadastrado por'} top={10}/>

            <LineContent data={{
                incident: data?.incident_timeline,
                solicitation: data?.solicitation_timeline,
                finalized: data?.finalized_timeline
            }} elementId={'life-cycle-chart'} title={'Ciclo de vida das solicitações'}/>

            <BarsContent data={data?.applicant} elementId={'applicant-chart'} title={'Solicitantes'} top={10}/>

            <BarsContent data={data?.organization} elementId={'organization-chart'} title={'Organizações'} top={10}/>

            <BarsContent data={data?.reason} elementId={'reason-chart'} title={'Naturezas'} top={10}/>

            <BarsContent data={data?.operation_group} elementId={'operation-group-chart'} title={'Grupos de operação'} top={10}
                         last={true} observation={'* Solicitações podem ter mais de um grupo de operação.'}/>

        </>
    );
};

export default GraphicsContent;